export var ConfigurationMethod;
(function (ConfigurationMethod) {
    ConfigurationMethod["network"] = "network";
    ConfigurationMethod["interface"] = "interface";
})(ConfigurationMethod || (ConfigurationMethod = {}));
